<template>
  <header class="medical-topbar">
    <div class="medical-topbar__main">
      <div class="medical-topbar__brand">
        <div class="medical-topbar__logo">39</div>
        <div>
          <div class="medical-topbar__title">健康药品演示站</div>
        </div>
      </div>
      <div v-if="showSearch" class="medical-topbar__search">
        <input
          :value="searchValue"
          :placeholder="searchPlaceholder"
          type="text"
          @input="onInput"
          @keyup.enter="onSearch"
        />
        <button type="button" @click="onSearch">搜索</button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "MedicalTopBar",
  props: {
    searchPlaceholder: {
      type: String,
      default: "搜索疾病 / 药品 / 症状",
    },
    searchValue: {
      type: String,
      default: "",
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onInput(event) {
      this.$emit("update:searchValue", event.target.value);
      this.$emit("search", event.target.value);
    },
    onSearch() {
      this.$emit("search", this.searchValue);
    },
  },
};
</script>

<style scoped>
.medical-topbar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: radial-gradient(
      circle at top left,
      rgba(32, 140, 115, 0.14),
      transparent 34%
    ),
    linear-gradient(180deg, #ffffff 0%, #f5fbf8 100%);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}
.medical-topbar__main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 18px 24px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.medical-topbar__brand {
  display: flex;
  align-items: center;
  gap: 14px;
}

.medical-topbar__logo {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: linear-gradient(135deg, #13966e, #0f766e);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  box-shadow: 0 12px 24px rgba(15, 118, 110, 0.22);
}

.medical-topbar__title {
  color: #0f172a;
  font-size: 20px;
  font-weight: 700;
}

.medical-topbar__search {
  min-width: 280px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.medical-topbar__search input {
  flex: 1;
  height: 42px;
  border-radius: 999px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: #ffffff;
  padding: 0 18px;
  font-size: 14px;
  outline: none;
}

.medical-topbar__search button {
  border: none;
  border-radius: 999px;
  height: 42px;
  padding: 0 18px;
  background: linear-gradient(135deg, #13966e, #0f766e);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.25);
}

@media (max-width: 960px) {
  .medical-topbar__main {
    flex-direction: column;
    align-items: stretch;
    gap: 18px;
  }

  .medical-topbar__search {
    flex: 1;
    min-width: 0;
  }
}

@media (max-width: 640px) {
  .medical-topbar__main {
    padding: 16px;
    gap: 16px;
  }

  .medical-topbar__title {
    font-size: 18px;
  }

  .medical-topbar__sub {
    font-size: 12px;
  }
}
</style>
